import Login from "../components/auth/login/index";
import Layout from "../components/layouts/allpagelayout";
export default function LoginPage() {
  return (
    <Layout>
      <Login />
    </Layout>
  );
}